import React from 'react'
import { Label } from '../ui/Label'
import { Input } from '../ui/Input'

export function ReadOnlyField({ label, value }: { label: string; value: string }) {
  return (
    <div className="space-y-1">
      <Label className="text-xs text-purple-700 dark:text-purple-300">{label}</Label>
      <div
        className="w-full rounded-md border border-purple-100 dark:border-purple-900/40 bg-purple-50/30 dark:bg-purple-900/10 px-3 py-2 text-sm text-slate-800 dark:text-slate-100"
        aria-label={label}
      >
        {value || <span className="text-slate-400 dark:text-slate-500 italic">—</span>}
      </div>
    </div>
  )
}

export function EditableOrReadOnlyField({
  label,
  value,
  fieldId,
  placeholder,
  disabled,
  registerProps,
  error,
}: {
  label: string
  value: string
  fieldId: string
  placeholder?: string
  disabled?: boolean
  registerProps?: React.InputHTMLAttributes<HTMLInputElement>
  error?: string
}) {
  if (value) {
    return <ReadOnlyField label={label} value={value} />
  }
  return (
    <div className="space-y-1">
      <Label
        htmlFor={fieldId}
        className="text-xs text-purple-700 dark:text-purple-300"
      >
        {label}
      </Label>
      <Input
        id={fieldId}
        aria-label={label}
        placeholder={placeholder || `Enter ${label.toLowerCase()}`}
        disabled={disabled}
        {...registerProps}
        className="border-purple-300 dark:border-purple-600 focus-visible:ring-purple-400"
      />
      {error && (
        <p className="text-xs text-red-600 dark:text-red-400" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}
